import request from "../utils/request";

export async function getRecipeList(payload) {
  return request.get("Recipe/List", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      recipeId: payload.recipe ? payload.recipe.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      productExtraId: payload.extra ? payload.extra.id : null,
      minCost: payload.cost && payload.cost.min ? payload.cost.min : null,
      maxCost: payload.cost && payload.cost.max ? payload.cost.max : null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
}

export async function getExcel(payload) {
  return request.get("Recipe/ExcelList", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      recipeId: payload.recipe ? payload.recipe.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      productExtraId: payload.extra ? payload.extra.id : null,
      minCost: payload.cost && payload.cost.min ? payload.cost.min : null,
      maxCost: payload.cost && payload.cost.max ? payload.cost.max : null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
}

export async function createNewRecipe(newRecipe) {
  return request.post("Recipe/Create", newRecipe);
}

export async function updateRecipe(recipe) {
  return request.post("Recipe/Update", recipe);
}

export async function deleteRecipe(id) {
  return request.delete('Recipe/Delete?id=' + id);
}

export async function copyRecipe(recipe) {
  return request.post("Recipe/CopyRecipe", recipe);
}

export async function fetchRecipeWithoutPrices(recipeId) {
  return request.get("Recipe", {
    params: {
      recipeId: recipeId
    }
  })
}
